export default function isCheckbox(type) {
  return ['gdpr', 'privacy', 'checkbox'].includes(type);
}
